import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label, Spinner } from 'reactstrap';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';
import withRouter from 'components/Common/withRouter';

// Formik validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// actions
import { loginUser, socialLogin } from '../../store/actions';

// import images
import profile from 'assets/images/profile-img.png';
import logo from 'assets/images/logo.svg';
import { getToken } from 'firebase/messaging';
// import { firebasemessaging } from 'common/FirebaseConfig';

const Login = props => {
	const [getFcmToken, setFcmToken] = useState('');
	const [isFcmTokenLoading, setFcmTokenLoading] = useState(false);
	//meta title
	document.title = 'Login | Customer Portal';

	const dispatch = useDispatch();

	const validation = useFormik({
		// enableReinitialize : use this  flag when initial values needs to be changed
		enableReinitialize: true,

		initialValues: {
			email: '',
			password: '',
			webDeviceToken: ''
		},
		validationSchema: Yup.object({
			email: Yup.string().required('Please Enter Your Email'),
			password: Yup.string().required('Please Enter Your Password')
		}),
		onSubmit: values => {
			values.webDeviceToken = getFcmToken;
			dispatch(loginUser(values, props.router.navigate));
		}
	});

	const LoginProperties = createSelector(
		state => state.Login,
		login => ({
			error: login.error,
			isLoading: login.loading
		})
	);

	const { error, isLoading } = useSelector(LoginProperties);

	const requestPermission = async () => {
		setFcmTokenLoading(true);
		await Notification.requestPermission()
			.then(() =>
				// getToken(firebasemessaging, {
				// 	vapidKey: 'BHC_ewJMALlDns7-bUoKQTheDifEndh-D4NUMCjqu0Cslx16O6vTqBF6s3TED5iLpBWHV6AxI_4pHYe2PSo-ixY'
				// })
				getToken()
			)
			.then(token => {
				setFcmToken(token);
				setFcmTokenLoading(false);
				// Send this token to your server to send notifications
			})
			.catch(err => {
				setFcmTokenLoading(false);
				setFcmToken('');
			});
	};

	useEffect(() => {
		requestPermission();
	}, []);

	return (
		<React.Fragment>
			<div className="account-pages my-5 pt-sm-5">
				<Container>
					<Row className="justify-content-center">
						<Col md={8} lg={6} xl={5}>
							<Card className="overflow-hidden">
								<div className="bg-primary-subtle">
									<Row>
										<Col className="col-7">
											<div className="text-primary p-4">
												<h5 className="text-primary">Welcome Back !</h5>
											</div>
										</Col>
										<Col className="col-5 align-self-end">
											<img src={profile} alt="" className="img-fluid" />
										</Col>
									</Row>
								</div>
								<CardBody className="pt-0">
									<div>
										<Link to="/" className="logo-light-element">
											<div className="avatar-md profile-user-wid mb-4">
												<span className="avatar-title rounded-circle bg-light">
													<img src={logo} alt="" className="rounded-circle" height="34" />
												</span>
											</div>
										</Link>
									</div>

									{!isFcmTokenLoading ? (
										<div className="p-2">
											<Form
												className="form-horizontal"
												onSubmit={e => {
													e.preventDefault();
													validation.handleSubmit();
													// return false;
												}}
											>
												{error ? <Alert color="danger">{error}</Alert> : null}

												<div className="mb-3">
													<Label className="form-label">Email</Label>
													<Input
														name="email"
														className="form-control"
														placeholder="Enter email"
														type="email"
														onChange={validation.handleChange}
														onBlur={validation.handleBlur}
														value={validation.values.email || ''}
														invalid={validation.touched.email && validation.errors.email ? true : false}
													/>
													{validation.touched.email && validation.errors.email ? (
														<FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
													) : null}
												</div>

												<div className="mb-3">
													<Label className="form-label">Password</Label>
													<Input
														name="password"
														value={validation.values.password || ''}
														type="password"
														placeholder="Enter Password"
														onChange={validation.handleChange}
														onBlur={validation.handleBlur}
														invalid={validation.touched.password && validation.errors.password ? true : false}
													/>
													{validation.touched.password && validation.errors.password ? (
														<FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
													) : null}
												</div>

												<div className="form-check">
													<input type="checkbox" className="form-check-input" id="customControlInline" />
													<label className="form-check-label" htmlFor="customControlInline">
														Remember me
													</label>
												</div>

												<div className="mt-3 d-grid">
													{isLoading || isFcmTokenLoading ? (
														<button disabled className="btn btn-primary btn-block">
															Loading ...{' '}
														</button>
													) : (
														<button className="btn btn-primary btn-block" type="submit">
															Log In
														</button>
													)}
												</div>
											</Form>
										</div>
									) : (
										<div className="text-center my-5 text-primary">
											<Spinner />
										</div>
									)}
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default withRouter(Login);

Login.propTypes = {
	history: PropTypes.object
};
